import React from 'react';
import AntiFraudToolSearchParams from './AntiFraudToolSearchParams';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import AntiFraudToolAdminItem from '../../../Domain/AntiFraudToolAdminItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import AntiFraudToolService from '../../../Services/AntiFraudToolService';

class AntiFraudToolAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchItem: new AntiFraudToolSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      allItemsInTheSearchSetAreSelected: false,
      popup: null,
      selected: -1,
      selectedInvoiceEvaluator: null,
      itemList: [],
      selectedItem: null,
      recordIds: [],
    };

    this.startSearch = this.startSearch.bind(this);
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  editPanelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  savePanelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={AntiFraudToolAdminItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={AntiFraudToolService.GetFraudHits}
          convertDBItemsFunction={AntiFraudToolService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          orderBy='RecordId'
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          showSearchStrip={true}
          searchParamsType={AntiFraudToolSearchParams}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          clickOnStartSearch={this.startSearch}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Record IDs, base or matched shopper name/email...'
        />
      </div>
    );
  }
}

export default AntiFraudToolAdmin;
